import React from "react";
import styles from "./AnimatedDownArrow.module.css";

const AnimatedDownArrow = () => {
  return (
    <div className={styles.animatedDownArrowWrapper}>
      <div className={styles.scrollToExploreText}>Scroll to explore</div>
      <div className={styles.animatedDownArrow}>
        <svg width="36" height="48" viewBox="0 0 36 48">
          {/* Stem */}
          <line
            x1="18"
            y1="8"
            x2="18"
            y2="28"
            stroke="#fff"
            strokeWidth="4"
            strokeLinecap="round"
          />
          {/* Arrowhead */}
          <polyline
            points="10,22 18,34 26,22"
            fill="none"
            stroke="#fff"
            strokeWidth="4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
    </div>
  );
};

export default React.memo(AnimatedDownArrow);